import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({ name: 'smTranslate' })
export class SmTranslatePipe implements PipeTransform {
	constructor(private _translationService: TranslationService) { }

	transform(value: string): string {
		return this._translationService.getString(value);
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/pipes/sm-translate.pipe.ts